import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartCircularPercentageComponent } from './chart-circular-percentage/chart-circular-percentage.component';
import { BaseChartDirective } from 'ng2-charts';
import { BarChartComponent } from './bar-chart/bar-chart.component';

@NgModule({
  imports: [
    CommonModule,
    BaseChartDirective
  ],
  exports: [
    ChartCircularPercentageComponent,
    BarChartComponent
  ],
  declarations: [
    ChartCircularPercentageComponent,
    BarChartComponent
  ]
})
export class ChartModule { }
